<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSearch_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.006 9.805h-.633l-.224-.216a5.18 5.18 0 0 0 1.257-3.386 5.203 5.203 0 1 0-5.203 5.203 5.18 5.18 0 0 0 3.386-1.257l.216.224v.633L13.807 15 15 13.807l-3.994-4.002Zm-4.803 0a3.597 3.597 0 0 1-3.602-3.602 3.597 3.597 0 0 1 3.602-3.602 3.597 3.597 0 0 1 3.602 3.602 3.597 3.597 0 0 1-3.602 3.602Z"
    />
</svg>
